export const sanityLocaleMap = (pagelang) => {
  return pagelang?.toLocaleLowerCase().replace('_', '-').replace('ja', 'jp').replace('gb', 'uk');
}